export default __webpack_public_path__ + "static/media/login_bg_diet@2x.d378802b.jpg";